import { useState, useEffect } from "react";
import { api } from "@/lib/api";
import { Trash2, Check, X, Phone, Mail } from "lucide-react";
import { toast } from "sonner";

const LABELS = { pending: "En attente", confirmed: "Confirmée", cancelled: "Annulée", completed: "Honorée" };

export default function ReservationsPanel() {
  const [list, setList] = useState([]);

  const load = async () => {
    try {
      const { data } = await api.get("/admin/reservations");
      setList(data);
    } catch { toast.error("Erreur de chargement"); }
  };

  useEffect(() => { load(); const i = setInterval(load, 15000); return () => clearInterval(i); }, []);

  const setStatus = async (id, status) => {
    await api.put(`/admin/reservations/${id}/status`, { status });
    toast.success("Statut mis à jour");
    load();
  };
  const del = async (id) => {
    if (!window.confirm("Supprimer cette réservation ?")) return;
    await api.delete(`/admin/reservations/${id}`);
    load();
  };

  return (
    <div data-testid="reservations-panel">
      <h1 className="font-display text-4xl mb-6">Réservations</h1>
      {list.length === 0 ? (
        <div className="text-center py-20 text-muted-foreground">Aucune réservation.</div>
      ) : (
        <div className="grid lg:grid-cols-2 gap-4">
          {list.map((r) => (
            <div key={r.id} data-testid={`resa-${r.id}`} className="bg-white border border-border rounded-sm p-5">
              <div className="flex justify-between items-start mb-3">
                <div>
                  <h3 className="font-display text-2xl">{r.firstname}</h3>
                  <p className="text-xs uppercase tracking-wider mt-1 inline-block px-2 py-1 bg-accent text-primary rounded-sm">{LABELS[r.status]}</p>
                </div>
                <div className="text-right">
                  <div className="text-xl font-semibold text-primary">{r.date}</div>
                  <div className="text-sm text-muted-foreground">{r.time} · {r.guests} pers.</div>
                </div>
              </div>
              <div className="space-y-1 text-sm">
                <p className="flex items-center gap-2"><Phone size={13} /> <a href={`tel:${r.phone}`} className="hover:underline">{r.phone}</a></p>
                <p className="flex items-center gap-2"><Mail size={13} /> <a href={`mailto:${r.email}`} className="hover:underline">{r.email}</a></p>
                {r.comment && <p className="italic text-muted-foreground mt-2">« {r.comment} »</p>}
              </div>
              <div className="flex gap-2 mt-4 pt-3 border-t border-border">
                {r.status === "pending" && (
                  <>
                    <button onClick={() => setStatus(r.id, "confirmed")} data-testid={`confirm-${r.id}`} className="flex-1 bg-primary text-white py-2 rounded-sm text-sm hover:bg-primary/90 flex items-center justify-center gap-1"><Check size={14} /> Confirmer</button>
                    <button onClick={() => setStatus(r.id, "cancelled")} className="px-4 border border-destructive text-destructive py-2 rounded-sm text-sm hover:bg-destructive hover:text-white"><X size={14} /></button>
                  </>
                )}
                {r.status === "confirmed" && (
                  <button onClick={() => setStatus(r.id, "completed")} className="flex-1 bg-foreground text-white py-2 rounded-sm text-sm hover:bg-foreground/90">Marquer comme honorée</button>
                )}
                <button onClick={() => del(r.id)} className="px-3 text-muted-foreground hover:text-destructive"><Trash2 size={14} /></button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
